import { useEffect, useMemo, useState } from 'react';
import { useWSMessage } from '../context/WSMessageContext';

export default function useWSSlideData() {
  const { messages } = useWSMessage();
  const [slideData, setSlideData] = useState(null);

  // Filtra mensagens do tipo STATE_CHANGE que contêm slideData
  const slideMessages = useMemo(() =>
    messages.filter(msg => 
      msg.type === 'STATE_CHANGE' && 
      msg.content && 
      msg.content.slideData
    ),
    [messages]
  );

  const roomJoinedMessages = useMemo(() =>
    messages.filter(msg => msg.type === 'room-joined'),
    [messages]
  );

  // Sincroniza slideData inicial quando entra na sala
  useEffect(() => {
    if (roomJoinedMessages.length === 0) return;

    const latestRoomJoined = roomJoinedMessages[roomJoinedMessages.length - 1];

    if (latestRoomJoined.currentState && latestRoomJoined.currentState.slideData) {
      setSlideData(latestRoomJoined.currentState.slideData);
    }
  }, [roomJoinedMessages]);

  // Atualiza slideData quando recebe mudanças do servidor
  useEffect(() => {
    if (slideMessages.length === 0) return;

    const latestSlideMessage = slideMessages[slideMessages.length - 1];

    if (latestSlideMessage.content && latestSlideMessage.content.slideData) {
      setSlideData(latestSlideMessage.content.slideData);
    }
  }, [slideMessages]);

  return { slideData };
}
